import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-one-one-one',
  templateUrl: './c1-one-one-one-one.component.html',
  styleUrls: ['./c1-one-one-one-one.component.scss']
})
export class C1OneOneOneOneComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.1.1_CURRICULUM DELIVERY/1.1.1.1_ACADMIC CALENDER KUK.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }

}
